import type { GridValueFormatterParams } from "@mui/x-data-grid";
import { when } from "util/support";

type Params = {
    readonly fallbackValue?: string;
};

const fallbackValue = ({
    fallbackValue = '-',
}: Params = {}) => ({ value }: GridValueFormatterParams<string>) => {
    if (
        (typeof value !== 'string') &&
        [null, undefined].includes(value)
    ) {
        return fallbackValue;
    }

    return when(
        String(value).trim().length,
        value,
        fallbackValue,
    );
};

export default fallbackValue;
